import React, { useEffect, useState } from 'react';
import './Preloader.css';
import { FaReact, FaNodeJs, FaDatabase } from 'react-icons/fa';
import logo from './logo.png'; // Your logo file

const Preloader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + (100 - prev) * 0.1; // Smooth deceleration
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="preloader">
      <div className="tech-grid"></div>
      <div className="preloader-content">
        <div className="pre-logo-container">
          <img 
            src={logo} 
            alt="e-Tech Pvt.Ltd." 
            className="pre-logo-image"
          />
          <div className="logo-text">e-Tech Pvt.Ltd.</div>
        </div>
        
        <div className="progress-container">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
        
        <div className="loading-text">
          🤖 AI Systems Initializing
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        
        <div className="tech-icons-preloader">
          <FaReact className="tech-icon-preloader" />
          <FaNodeJs className="tech-icon-preloader" />
          <FaDatabase className="tech-icon-preloader" />
        </div>
      </div>
    </div>
  );
};

export default Preloader;